<script setup>
import { onMounted, onUnmounted, computed, ref, watch } from 'vue';
import Login from '../Popups/Login.vue';
import LogoutConfirmation from '../Popups/LogoutConfirmation.vue';
// import OpenDrawer from './OpenDrawer.vue';
// import ItemsSearch from './ItemsSearchButton.vue';
import AddComment from './AddCommentButton.vue';
import AddBehavior from '../Popups/AddBehavior.vue';
import AddManagerApproval from './AddManagerApprovalButton.vue';
import WalkInCustomer from './WalkInCustomerButton.vue';
import ManagerLogin from '../Popups/ManagerLogin.vue';
import Comments from '../Popups/Comments.vue'
import OrderCommentPopup from '../Popups/OrderCommentPopup.vue';
import AddCustomer from '../Popups/AddCusotmer.vue'
import msgIcon from '/message.svg';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import { useAuthStore } from '@/stores/authStore';
import { useOrderStore } from '@/stores/OrderStore';
import ServiceMenuButton from './Buttons/ServiceMenuButton.vue';
import AddManualOrderButton from './Buttons/AddManualOrderButton.vue';
import ClosingBalancePopup from '../Popups/ClosingBalancePopup.vue';
import OpeningBalancePopup from '../Popups/OpeningBalancePopup.vue';
import OpenCloseShift from './Buttons/OpenCloseShift.vue';

const authStore = useAuthStore();
const orderStore = useOrderStore();

const logoutRole = ref(null); 

// Modal control for Login
const modalActive = ref(null);
const toggleModal = () => {
  modalActive.value = !modalActive.value;

  localStorage.setItem('lastUser', JSON.stringify({
        currentUser: authStore.currentUser,
        userRole: authStore.userRole,
        managerUser: authStore.managerUser,
        managerRole: authStore.managerRole,
      }));
};

const toggleisLogoutConfirmationVisible = (role) => {
  logoutRole.value = role;
  authStore.isLogoutConfirmationVisible = !authStore.isLogoutConfirmationVisible;
};

const handleAuthAction = (role) => {
  if (role === 'Cashier' && authStore.isUserLoggedIn) {
    toggleisLogoutConfirmationVisible('Cashier');
  } else if (role === 'Manager' && authStore.isManagerLoggedIn) {
    toggleisLogoutConfirmationVisible('Manager');
  } else {
    toggleModal();
  }
};

// Tooltip for login button
const myButton = ref(null);
let tooltipInstance = null;

onMounted(() => {
  tooltipInstance = tippy(myButton.value, {
    content: authStore.isUserLoggedIn ? 'Logout' : 'Login',
    placement: 'top',
    animation: 'fade',
  });
});

watch(() => authStore.isUserLoggedIn, (newValue) => {
  if (tooltipInstance) {
    tooltipInstance.setContent(newValue ? 'Logout' : 'Login');
  }
});

// Countdown and inactivity logic
// const totalInactivityTime = 180; 
// const countdown = ref(totalInactivityTime);
// const showCountdown = ref(false);
// let countdownInterval = null;

// const formattedCountdown = computed(() => {
//   const minutes = Math.floor(countdown.value / 60);
//   const seconds = countdown.value % 60;
//   return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
// });

// const startCountdown = () => {
//   clearInterval(countdownInterval);
//   countdown.value = totalInactivityTime;
//   showCountdown.value = false;

//   countdownInterval = setInterval(() => {
//     if (countdown.value > 0) {
//       countdown.value -= 1;
      
//       // Show countdown when half time
//       if (countdown.value <= totalInactivityTime / 2) {
//         showCountdown.value = true;
//       }
//     } else {
//       clearInterval(countdownInterval);

//       localStorage.setItem('lastUser', JSON.stringify({
//         currentUser: authStore.currentUser,
//         userRole: authStore.userRole,
//         managerUser: authStore.managerUser,
//         managerRole: authStore.managerRole,
//       }));

//       if (authStore.userRole) {
//         authStore.logout(authStore.userRole);
//       }
//       if (authStore.managerRole) {
//         authStore.logout(authStore.managerRole);
//       }
//     }
//   }, 1000);
// };

// const resetCountdown = () => {
//   startCountdown();
// };

const handleManagerApproval = () => {
  authStore.toggleManagerLoginPopup();
  console.log('Manager approval triggered successfully!');
};

const handleWalkInCustomer = () => {
  authStore.toggleAddCustomerPopup();
  console.log('Walk-in customer triggered successfully!');
};

const showOrderCommentPopup = ref(false);

const handleCommentAdded = () => {
  showOrderCommentPopup.value = true;
};

// watch(() => authStore.isUserLoggedIn || authStore.isManagerLoggedIn, (isLoggedIn) => {
//   if (isLoggedIn) {
//     startCountdown();
//     window.addEventListener('mousemove', resetCountdown);
//     window.addEventListener('keydown', resetCountdown);
//   } else {
//     clearInterval(countdownInterval);
//     countdown.value = totalInactivityTime;
//     window.removeEventListener('mousemove', resetCountdown);
//     window.removeEventListener('keydown', resetCountdown);
//   }
// });

// onMounted(() => {
//   if (authStore.isUserLoggedIn || authStore.isManagerLoggedIn) {
//     startCountdown();
//     window.addEventListener('mousemove', resetCountdown);
//     window.addEventListener('keydown', resetCountdown);
//   }
// });

// onUnmounted(() => {
//   clearInterval(countdownInterval);
//   window.removeEventListener('mousemove', resetCountdown);
//   window.removeEventListener('keydown', resetCountdown);
// });

const hasEmptyComment = ref(false);
const getAllComments = ref([]);

const updateComments = () => {
  const storedState = JSON.parse(localStorage.getItem('newOrder')) || {};
  getAllComments.value = storedState.comments || [];
  hasEmptyComment.value = getAllComments.value.some(comment => !comment.text.trim());
};

onMounted(() => {
  updateComments();
});
window.addEventListener('comment-saved', updateComments);
</script>

<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 overflow-y-auto" style="max-height: 550px;">
    <LogoutConfirmation v-if="authStore.isLogoutConfirmationVisible" :role="logoutRole" />
    <Login @close-modal="toggleModal" :modalActive="modalActive" />
    <ManagerLogin />
    <AddCustomer />
    
    <!-- Cashier Section -->
    <div class="relative flex items-center bg-white w-full p-5 rounded-2xl gap-5 my-3">  
      <div>
        <button class="flex flex-col items-center">
          <img style="width: 30px;" src="/cashier.png" alt="">
          <span class="font-semibold">{{ authStore.isUserLoggedIn ? authStore.userRole : 'Cashier' }}</span>
        </button>
      </div>
      <i @click="handleAuthAction('Cashier')" ref="myButton" class="pi pi-user text-purple-500 bg-purple-100 p-4 rounded-full cursor-pointer" style="font-size: 1.875rem;"></i>
      <span class="font-medium">{{authStore.isUserLoggedIn ? authStore.currentUser : authStore.isManagerLoggedIn ? 'Logged In' : 'Logged Out'}}</span>
      <!-- Countdown Timer -->
      <!-- <span v-if="authStore.isUserLoggedIn && showCountdown" class="absolute bottom-2 right-2 flex items-center gap-2">
        <p>{{ formattedCountdown }}</p>
        <i class="pi pi-clock" style="font-size: 20px;"></i>
      </span> -->
    </div>

    <!-- Manager Section -->
    <div v-show="authStore.isManagerLoggedIn" class="relative flex items-center justify-start bg-white w-full py-2 px-2 gap-3 rounded-2xl my-3">  
      <div>
        <button class="flex flex-col items-center">
          <img style="width: 30px;" src="/manager.svg" alt="Manager Image">
          <span class="font-semibold">{{ authStore.isManagerLoggedIn ? authStore.managerRole : 'Manager' }}</span>
        </button>
      </div>
      <i @click="handleAuthAction('Manager')" ref="myButton" class="pi pi-user text-purple-500 bg-purple-100 p-4 rounded-full cursor-pointer" style="font-size: 1.875rem;"></i>
      <span class="font-medium">{{ authStore.isManagerLoggedIn ? authStore.managerUser : 'Logged out' }}</span>

      <img 
        v-if="orderStore.state.comments.length > 0"
        :src="msgIcon" 
        :class="hasEmptyComment ? 'bg-red-400' : 'bg-green-400'" 
        class="rounded-md cursor-pointer p-2" 
        alt="Comment Icon" 
        @click="authStore.toggleShowCommentsModal"
      />

      <!-- Manager Countdown Timer -->
      <!-- <span v-if="authStore.isOnlyManagerLoggedIn && showCountdown" class="absolute bottom-2 right-2 flex items-center gap-2">
        <p>{{ formattedCountdown }}</p>
        <i class="pi pi-clock" style="font-size: 20px;"></i>
      </span> -->
    </div>

    <!-- <ItemsSearch v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn" /> -->
    <ServiceMenuButton v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn" />
    <AddManualOrderButton v-if="(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) && authStore.canBranchDoManualOrder" />
    <!-- <OpenDrawer v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn" /> -->
    <OpenCloseShift v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn" />
    <AddBehavior v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn"  />
    <ClosingBalancePopup />
    <OpeningBalancePopup />
    
    <AddComment
      v-if="authStore.isUserLoggedIn || authStore.isManagerLoggedIn"
      @click="handleCommentAdded"
    />
    <OrderCommentPopup
      v-if="showOrderCommentPopup"
      @close="showOrderCommentPopup = false"
    />
   
    <AddManagerApproval 
     v-if="authStore.isAddManagerApprovalButtonMoved" 
     @click="handleManagerApproval" 
    />
    <WalkInCustomer 
     v-if="authStore.isWalkInCustomerButtonMoved || orderStore.state.customer.name != '' || orderStore.state.customer.id != ''"
     @click="handleWalkInCustomer"
    />
    <button
      :disabled="!(authStore.isUserLoggedIn || authStore.isManagerLoggedIn)"
      @click="authStore.toggleAddBehaviourPopup"
      class="bg-white w-full text-center p-5 rounded-2xl flex gap-5 my-3 cursor-pointer">
      <span class="text-center mx-auto cursor-pointer">
        <i class="pi pi-plus text-purple-500 bg-purple-100 p-4 rounded-full" :class="{ 'opacity-50 cursor-not-allowed': !(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) }" style="font-size: 1.875rem;"></i>
      </span>
    </button>

    <Comments v-if="authStore.showCommentsModal && (authStore.isUserLoggedIn || authStore.isManagerLoggedIn)" @close="authStore.toggleShowCommentsModal" />
  </div>
</template>

<style scoped>
</style>